import { FunctionComponent, ReactNode } from "react";
import { useAngularReactRouterSync } from "./legacy/angularApp";
import { useNavigation } from "react-router";
import { LoadingBar } from "./LoadingBar";
import { WebClientContexts } from "./WebClientContexts";

/**
 * Main application container.
 * @returns
 */
export const WebClientApp: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  useAngularReactRouterSync();
  const { state: navigationState } = useNavigation();

  return (
    <WebClientContexts>
      <LoadingBar loading={navigationState !== "idle"} />
      {children}
    </WebClientContexts>
  );
};
